module.exports = __webpack_public_path__ + "static/specialists-slideshow-06-5809d69e22f52cc46a1c28a100ca2165.jpg";